import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from '@app/header/header.component';
import { LocationSelectorComponent } from '@app/header/location-selector/component';
import { ConfirmComponent } from '@app/shared/confirm/component';
import { NotificationsComponent } from '@app/header/notifications/component';
import { SharedModule } from '@app/shared/shared.module';

import {
    NbOverlayModule,
    NbDialogModule,
    NbContextMenuModule,
    NbMenuModule,
    NbLayoutModule,
    NbIconModule,
    NbActionsModule,
    NbPopoverModule,
    NbCardModule,
    NbListModule,
    NbSpinnerModule,
    NbButtonModule,
    NbTabsetModule,
} from '@nebular/theme';
import { UsageAlertNotificationComponent } from './notifications/notification-types/usage-alert/usage-alert.component';
import { HeartbeatNotificationComponent } from './notifications/notification-types/heartbeat/heartbeat.component';
import { BatteryNotificationComponent } from './notifications/notification-types/battery/battery.component';
import { BudgetNotificationComponent } from './notifications/notification-types/budget/budget.component';
import { GeneralNotificationComponent } from './notifications/notification-types/general/general.component';
import { DeviceMovedComponent } from './notifications/notification-types/device-moved/device-moved.component';
import { InfoDialogComponent } from '@app/shared/info-dialog/info-dialog.component';

@NgModule({
    declarations: [
        HeaderComponent,
        LocationSelectorComponent,
        ConfirmComponent,
        NotificationsComponent,
        UsageAlertNotificationComponent,
        HeartbeatNotificationComponent,
        BatteryNotificationComponent,
        BudgetNotificationComponent,
        GeneralNotificationComponent,
        DeviceMovedComponent,
    ],
    entryComponents: [LocationSelectorComponent, ConfirmComponent, InfoDialogComponent],
    imports: [
        CommonModule,
        SharedModule,
        NbDialogModule.forChild(),
        NbOverlayModule,
        NbMenuModule,
        NbContextMenuModule,
        NbLayoutModule,
        NbIconModule,
        NbActionsModule,
        NbPopoverModule,
        NbCardModule,
        NbListModule,
        NbSpinnerModule,
        NbButtonModule,
        NbTabsetModule,
    ],
    providers: [],
    exports: [HeaderComponent, LocationSelectorComponent, HeartbeatNotificationComponent],
})
export class HeaderModule {}
